<template>
  <el-dialog title="配置积分奖励" :visible.sync="show" :close-on-click-modal="false">
    <div class="nav-panel">
      <draggable v-model="configs" draggable=".nav" handle=".nav-sort-btn" class="navs">
        <div v-for="(config, index) in configs" :key="index" class="nav">
          <i class="iconfont icon-sort nav-sort-btn" />
          <el-input v-model="config.score" type="text" size="small" placeholder="积分"></el-input>
          <el-input
            v-model="config.goodsId"
            type="text"
            size="small"
            placeholder="商品ID"
          ></el-input>
          <el-button
            type="danger"
            icon="el-icon-delete"
            circle
            size="small"
            @click="delConfig(index)"
          ></el-button>
        </div>
      </draggable>
      <div class="add-nav">
        <el-tooltip class="item" effect="dark" content="点击按钮添加导航" placement="top">
          <el-button type="primary" icon="el-icon-plus" circle @click="addConfig"></el-button>
        </el-tooltip>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="saveConfigs">保存配置</el-button>
    </span>
  </el-dialog>
</template>

<script>
import draggable from "vuedraggable";

export default {
  components: { draggable },
  data() {
    return {
      show: false,
      configs: [],
    };
  },
  methods: {
    async open() {
      await this.getConfigs();
      this.show = true;
    },
    async getConfigs() {
      try {
        this.configs = await this.axios.get("base:/api/admin/lucky-draw-prize/reward_configs");
      } catch (e) {
        // this.$notify.error({ title: "错误", message: e.message || e });
      }
    },
    async saveConfigs() {
      try {
        await this.axios.post("base:/api/admin/lucky-draw-prize/reward_configs", this.configs);
        this.$message({ message: "保存成功", type: "success" });
      } catch (e) {
        // this.$notify.error({ title: "错误", message: e.message || e });
      }
    },
    addConfig() {
      if (!this.configs) {
        this.configs = [];
      }
      this.configs.push({
        score: null,
        goodsId: null,
      });
    },
    delConfig(index) {
      if (!this.configs) {
        return;
      }
      this.configs.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.nav-panel {
  .navs {
    border: 1px solid #ddd;
    border-radius: 5px;

    .nav {
      display: flex;
      padding: 5px 5px;
      align-items: center;

      &:not(:last-child) {
        border-bottom: 1px solid #ddd;
      }

      .nav-sort-btn {
        font-size: 21px;
        font-weight: 700;
        cursor: pointer;
        float: right;
      }
    }
  }

  .add-nav {
    margin-top: 20px;
    text-align: center;
  }
}
</style>
